//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Компонент "курсора"
// в 4-х переменных-массивах селекторы элементов, на которых должны быть какая-то реакция
// в нагрузку к компоненту идёт директива v-cursor-anchor (~/plugins/cursorAnchor.js):
// v-cursor-anchor – помечает элемент как "эй курсор! реагируй на меня!"
// в неё можно передать режим v-cursor-anchor="{ mode: 'big' }"
// режима 3: big(он используется по умолчанию) – большой круг, small – маленький круг, hidden – скрыть "курсор"
// обособлено стоит иконка v-cursor-anchor="{ icon: 'eye' }"
// важно про иконку – она должна лежать в assets/sprite/svg и иметь префикс cursor-

import { debounce } from '@/utils/utils'

const smallStateSelectors = ['[data-cursor-anchor="small"]']
const stickyStateSelectors = ['[data-cursor-anchor="sticky"]']

const bigStateSelectors = [
  'a',
  'input:not(:disabled)',
  '.form-policy-item',
  '.multiselect',
  '[data-cursor-anchor=""]',
  '[data-cursor-anchor="big"]',
  '.gallery-tabs-item'
]

const hiddenSelectors = [
  'button',
  'button:disabled',
  '.form-sum-item',
  '.radio',
  '.multiselect__content-wrapper',
  '.search-genre-item',
  '.switch',
  '[data-cursor-anchor="hidden"]',
  '.header-round-btn',
  'iframe'
]

const hoverSelectors = [...smallStateSelectors, ...bigStateSelectors, ...hiddenSelectors, ...stickyStateSelectors]

const MODE_HIDDEN = 'hidden'

export {
  MODE_HIDDEN
}

export default {
  data () {
    return {
      x: 0,
      y: 0,
      width: null,
      height: null,
      cursorState: 'hidden',
      prevTarget: null,
      animate: false,
      icon: null
    }
  },
  computed: {
    hoverDebounced () {
      return debounce(this.hoverHandler, 10, true)
    },
    leaveDebounced () {
      return debounce(this.leave, 10, true)
    },
    moveHandlerDebounced () {
      return debounce(this.moveHandler, 2, true)
    },
    dimensionStyles () {
      let size = null
      if (this.width || this.height) {
        size = (this.width > this.height ? this.width : this.height) + 'px'
      }

      return {
        width: size,
        height: size
      }
    },
    hovered () {
      return !!this.cursorState
    }
  },
  mounted () {
    document.addEventListener('pointermove', this.moveHandlerDebounced, true)
    document.addEventListener('pointerleave', this.documentLeaveHandler)
  },
  beforeDestroy () {
    document.removeEventListener('pointermove', this.moveHandlerDebounced, true)
    document.removeEventListener('pointerleave', this.documentLeaveHandler)
  },
  methods: {
    moveHandler (e) {
      const target = e.target !== document ? e.target.closest(hoverSelectors.join(',')) : null

      const icon = target ? target.dataset.cursorAnchorIcon : null

      this.icon = icon

      if (target && target.closest(stickyStateSelectors.join(','))) {
        this.stickToElement(target.closest(stickyStateSelectors.join(',')))
      } else {
        this.animate = false
        this.x = e.clientX
        this.y = e.clientY
        this.width = null
        this.height = null
      }

      if (!target && this.cursorState === 'hidden') {
        this.cursorState = null
      }

      if (target !== this.prevTarget) {
        this.prevTarget = target

        if (target) {
          if (target.closest(hiddenSelectors.join(','))) {
            this.cursorState = 'hidden'
          } else if (icon) {
            this.cursorState = 'icon'
          } else if (target.closest(smallStateSelectors.join(','))) {
            this.cursorState = 'small'
          } else if (target.closest(bigStateSelectors.join(','))) {
            this.cursorState = 'big'
          }
        } else {
          this.cursorState = null
        }
      }
    },
    stickToElement (el) {
      const rect = el.getBoundingClientRect()
      this.animate = true
      this.width = rect.width
      this.height = rect.height
      this.x = rect.left + rect.width / 2
      this.y = rect.top + rect.height / 2
    },
    documentLeaveHandler () {
      this.prevTarget = null
      this.cursorState = 'hidden'
    }
  }
}
